import api from '../../../services/dealer/axios';

async function getOrderDetailDms(params) {
  const { data } = await api.get('orderDetail', {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return data.data;
}

export default function createApiOrderRepository() {
  return {
    getOrderDetailDms,
  };
}
